// extracted by mini-css-extract-plugin
export default {"wrapper":"ConstructorNavComponent_wrapper__zU-Xv","item_nav_active":"ConstructorNavComponent_item_nav_active__-NLeB","item_nav":"ConstructorNavComponent_item_nav__gwtUK"};